import { FormData } from './types';

export const formatNumber = (value: string): string => {
  const num = parseFloat(value.replace(/,/g, ''));
  if (isNaN(num)) return '0';
  return num.toLocaleString('en-US');
};

export const calculateResults = (formData: FormData) => {
  // Parse numeric values
  const salary = parseFloat(formData.salary.replace(/,/g, '')) || 0;
  const bonus = parseFloat(formData.bonus.replace(/,/g, '')) || 0;
  const totalIncome = salary + bonus;

  // Calculate monthly expenses
  const monthlyExpenses = Object.values(formData.expenses).reduce((sum, value) => {
    return sum + (parseFloat(value.replace(/,/g, '')) || 0);
  }, 0);

  // Calculate time off
  const totalTimeOff = Object.values(formData.timeOff).reduce((sum, value) => {
    return sum + (parseFloat(value) || 0);
  }, 0);

  // Calculate working hours
  const workDays = 260 - Number(totalTimeOff); // 52 weeks * 5 days - time off
  const workHours = workDays * 8;
  const effectiveHours = Math.floor(workHours * (parseInt(formData.productivityRate) / 100));

  // Calculate hourly rate
  const annualCosts = monthlyExpenses * 12;
  const riskBuffer = totalIncome * 0.1; // 10% buffer for unexpected expenses
  const totalCosts = totalIncome + annualCosts + riskBuffer;
  const hourlyRate = Math.ceil(totalCosts / effectiveHours);

  return {
    totalIncome,
    monthlyExpenses,
    annualCosts,
    riskBuffer,
    totalCosts,
    workDays,
    workHours,
    effectiveHours,
    hourlyRate,
    dailyRate: hourlyRate * 8,
    weeklyRate: hourlyRate * 40,
    monthlyRate: hourlyRate * 160
  };
};